import React, { useEffect, useState } from 'react'
import { CardSummary } from '../../components/CardSummary'
import { ModalSummary } from '../../components/ModalSummary';
import { useDispatch, useSelector } from 'react-redux';
import { loadIndicatorsOrders, loadIndicatorsProducts } from '../../app/store/Thunks';
import { Loading } from '../../components/Loading';
import { FiAlertCircle } from 'react-icons/fi';


export const Dashboard = ({ navigateTo }) => {

  // Control para mostrar los detalles de cada indicador
  const [showModal, setShowModal] = useState(false);
  const [searchType, setSearchType] = useState(null);

  const { isLoading, productsIndicators, ordersIndicators, msg, status } = useSelector(state => state.inventario);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadIndicatorsProducts());
    dispatch(loadIndicatorsOrders());
  }, [])

  const handleOpenModal = (type) => {
    //   // setSearchType(type);
    //   // setShowModal(true);  
  };

  const handleCloseModal = () => {
    //   // setShowModal(false);
    //   // setSearchType(null);
  };

  const goToProducts = (id) => {
    navigateTo('products', { ACTIVE: id });
  };

  const goToRequests = (id) => {
    navigateTo('requests', { STATUSID: id });
  };


  if (isLoading) {
    return (
      <Loading />
    )
  }
  return (
    <>

      {showModal && (<ModalSummary type={searchType} onClose={handleCloseModal} closeOnEscape={true} closeOnBackdrop={true} />)}
      <div className='row'>
        <h1 className="h3 fw-bold">
          Indicadores
        </h1>
      </div>
      {/* Indicadores para los productos */}
      <div className='row mt-4'>

       
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center  ">
          <h1 className="h4 fw-bold mb-3">Productos</h1>
        </div>

        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Existencias Optimas'} value={productsIndicators?.OPTIMO} onClick={() => goToProducts(1)} icon={'arrowGreen'} searchType={1} />
        </div>
        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Existencias Bajas'} value={productsIndicators?.BAJO} onClick={() => goToProducts(2)} icon={'arrowAmbar'} searchType={2} />
        </div>
        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Existencias Minimas'} value={productsIndicators?.MINIMO} onClick={() => goToProducts(3)} icon={'arrowRed'} searchType={3} />
        </div>
        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Agotados'} value={productsIndicators?.AGOTADO} onClick={() => goToProducts(5)} icon={'cancel'} searchType={3} />
        </div>
        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Por Resurtir'} value={productsIndicators?.RESURTIR} onClick={() => goToProducts(4)} icon={'exclamationRed'} searchType={3} />
        </div>
        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Orden Activa'} value={productsIndicators?.PRODUCTOS_ORDEN_ACTIVA} onClick={() => goToProducts(0)} icon={'orderProcess'} searchType={5} />
        </div>


      </div>

      {/* Indicadores para las solicitudes de compra */}
      <div className='row mt-4'>
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center  ">
          <h1 className="h4 fw-bold mb-3">Ordenes de compra</h1>
        </div>
         <div className='col-12'>
          <div className="alert alert-light border" role="alert">
            <FiAlertCircle size={22}/> <span className='ms-2 fw-bold'>Los indicadores mostrados corresponden a la actividad del mes en curso</span>
          </div>
        </div>

        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Solicitado'} value={ordersIndicators?.SOLICITADO} icon={'orderList'} searchType={6} onClick={() => goToRequests(1)} />
        </div>
        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Revisado'} value={ordersIndicators?.REVISADO} icon={'orderProcess'} searchType={8} onClick={() => goToRequests(2)} />
        </div>
        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Aprobado'} value={ordersIndicators?.APROBADO} icon={'orderAproved'} searchType={7} onClick={() => goToRequests(3)} />
        </div>
        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Recibido Parcial'} value={ordersIndicators?.PARCIAL} icon={'orderProcess'} searchType={8} onClick={() => goToRequests(5)} />
        </div>
        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Completo'} value={ordersIndicators?.COMPLETO} icon={'orderSuccess'} searchType={8} onClick={() => goToRequests(6)} />
        </div>
        <div className='col-6 col-sm-6 col-md-2 col-lg-2 col-xl-2 col-xxl-2'>
          <CardSummary title={'Cancelado'} value={ordersIndicators?.CANCELADO} icon={'cancel'} searchType={8} onClick={() => goToRequests(7)} />
        </div>


      </div>

    </>
  )
}
